import { LogChannel, LoggingMessageInterface } from '@rx-applications/shared/logging';

export enum EventName {
  LandedManageEmployees = 'LandedManageEmployees',
  LandedCustomFields = 'LandedOnCusotmFieldsWebsiteDetailsPage',
  ChangedUserSettings = 'ChangedUserSettings',
  CustomFieldValueUpdate = 'CustomFieldValueUpdate',
  CustomFieldMandatoryUpdate = 'CustomFieldMandatoryUpdate',
  LandedOnCustomFieldValuesPage = 'LandedOnCustomFieldValuesPage',
}

export const LogChannelMessageMappings: Record<
  EventName,
  { channels: LogChannel[]; message: LoggingMessageInterface; props?: Record<string, string> }
> = {
  [EventName.LandedManageEmployees]: {
    channels: [LogChannel.Amplitude],
    message: { name: EventName.LandedManageEmployees } as LoggingMessageInterface,
  },
  [EventName.LandedCustomFields]: {
    channels: [LogChannel.Amplitude],
    message: { name: EventName.LandedCustomFields } as LoggingMessageInterface,
  },
  [EventName.ChangedUserSettings]: {
    channels: [LogChannel.Amplitude],
    message: { name: EventName.ChangedUserSettings, type: 'action', props: {} } as LoggingMessageInterface,
  },
  [EventName.CustomFieldValueUpdate]: {
    channels: [LogChannel.Amplitude],
    message: { name: EventName.LandedCustomFields } as LoggingMessageInterface
  },
  [EventName.LandedOnCustomFieldValuesPage]: {
    channels: [LogChannel.Amplitude],
    message: { name: EventName.LandedOnCustomFieldValuesPage } as LoggingMessageInterface
  },
  [EventName.CustomFieldMandatoryUpdate]: {
    channels: [LogChannel.Amplitude],
    message: { name: EventName.CustomFieldMandatoryUpdate } as LoggingMessageInterface
  },
};
